import { Skeleton } from "antd";
import { METRICS_CONFIG } from "features/dashboard/sections/weeklyActivity/metricsConfig";
import * as styles from "features/dashboard/sections/weeklyActivity/funnelChart/funnelChart.module.scss";
import { Tooltip } from "common/components/tooltip/tooltip";
import { Flex } from "common/components/flex/flex";
import { Circle } from "common/components/circle/circle";

const STEP_REDUCTION = 8.5;

const FUNNEL_ROWS = [
  METRICS_CONFIG.slice(0, 2),
  ...METRICS_CONFIG.slice(2).map((m) => [m]),
];

const getRowTotal = (row, metrics) =>
  row.reduce((sum, m) => sum + (metrics[m.key]?.total ?? 0), 0);

const getRowKey = (row) => row.map((m) => m.key).join("-");

const getConversionRate = (current, previous) => {
  if (!previous) return 0;
  return Math.round((current / previous) * 100);
};

const FunnelSkeleton = () => {
  return (
    <div className={styles.funnelSkeleton}>
      {FUNNEL_ROWS.map((row) => (
        <div key={getRowKey(row)} className={styles.funnelSkeleton__stage}>
          <Skeleton.Input active />
        </div>
      ))}
    </div>
  );
};

export const FunnelChart = ({ metrics, loading = false }) => {
  const getTooltipTitle = (metric) => (
    <Flex align="center" gap={8}>
      <Circle color={metric.color} />
      <span>{metric.label}</span>
    </Flex>
  );

  if (loading) {
    return <FunnelSkeleton />;
  }

  return (
    <div className={styles.funnel}>
      {FUNNEL_ROWS.map((row, rowIndex) => {
        const width = 100 - rowIndex * STEP_REDUCTION;
        const prevTotal =
          rowIndex > 0 ? getRowTotal(FUNNEL_ROWS[rowIndex - 1], metrics) : null;

        return (
          <Flex
            key={getRowKey(row)}
            style={{
              flexGrow: 1,
              width: `${width}%`,
            }}
          >
            {row.map((metric) => {
              const count = metrics[metric.key]?.total ?? 0;
              const rate =
                prevTotal !== null ? getConversionRate(count, prevTotal) : null;

              return (
                <Tooltip
                  title={getTooltipTitle(metric)}
                  placement={rowIndex === 0 ? "top" : "right"}
                  key={metric.key}
                >
                  <div
                    className={styles.funnel__stage}
                    style={{
                      backgroundColor: metric.color,
                      width: row.length > 0 ? `${100 / row.length}%` : "100%",
                    }}
                  >
                    <div>
                      <span className="font-weight-heavy">{count}</span>
                      {rate !== null && <span>{` (${rate}%)`}</span>}
                    </div>
                  </div>
                </Tooltip>
              );
            })}
          </Flex>
        );
      })}
    </div>
  );
};
